// Simple analytics tracking utility
import { API_BASE } from './apiBase';

class Analytics {
  constructor() {
    this.baseUrl = API_BASE;
  }

  async track(eventType, data = {}) {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/json',
      };
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      await fetch(`${this.baseUrl}/api/analytics/track`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          event_type: eventType,
          data: data
        }),
      });
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }

  // Specific event methods for common events
  trackPageView(page) {
    this.track('view_home', { page });
  }

  trackProductView(productId) {
    this.track('view_product', { product_id: productId });
  }

  trackCheckoutStart(packageId) {
    this.track('start_checkout', { package_id: packageId });
  }

  trackPurchaseSuccess(packageId, sessionId) {
    this.track('purchase_succeeded', { 
      package_id: packageId, 
      session_id: sessionId 
    });
  }

  trackPasswordResetRequest(email) {
    this.track('reset_password_requested', { email });
  }

  trackToolkitUnlock(toolkitId) {
    this.track('toolkit_unlocked', { toolkit_id: toolkitId });
  }

  trackConsultationRequest(caseType) {
    this.track('consult_requested', { case_type: caseType });
  }
}

// Create singleton instance
const analytics = new Analytics();

// Make it available globally
if (typeof window !== 'undefined') {
  window.analytics = analytics;
}

export default analytics;